import React from 'react';
import {
  FundScenariosStore,
  KPIStore,
  SnackbarStore,
} from 'stores';

export const storesContext = React.createContext({
  fundScenarioStore: new FundScenariosStore(),
  appStore: new SnackbarStore(),
  KPIStore: new KPIStore(),
});
